import PropTypes from "prop-types";
import React from "react";
export const PlusCircle = ({
  colour = "#fdba12"
}) => /*#__PURE__*/React.createElement("svg", {
  id: "add_circle_outline_black_48dp",
  xmlns: "http://www.w3.org/2000/svg",
  width: "30.146",
  height: "30.146",
  viewBox: "0 0 30.146 30.146"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_668",
  "data-name": "Path 668",
  d: "M0,0H30.146V30.146H0Z",
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_669",
  "data-name": "Path 669",
  d: "M15.817,8.28H13.3V13.3H8.28v2.512H13.3v5.024h2.512V15.817h5.024V13.3H15.817ZM14.561,2A12.561,12.561,0,1,0,27.121,14.561,12.565,12.565,0,0,0,14.561,2Zm0,22.609A10.049,10.049,0,1,1,24.609,14.561,10.062,10.062,0,0,1,14.561,24.609Z",
  transform: "translate(0.512 0.512)",
  fill: colour
}));
PlusCircle.propTypes = {
  colour: PropTypes.string
};